/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl = '';
let routerMode = 'history';
let baseImgPath;
let logout = "/"
if (process.env.NODE_ENV == 'development') {
  baseUrl = 'https://fkcmdm.fresenius-kabi-sspc.com/service/';

} else if (window.location.host == 'fkcmdm.fresenius-kabi-sspc.com') {
  baseUrl = 'https://fkcmdm.fresenius-kabi-sspc.com/service/';
} else if (window.location.host == 'mdmuat.fresenius-kabi.com.cn') {
  baseUrl = 'https://mdmuat.fresenius-kabi.com.cn/service/';
} else if (window.location.host == 'mdm.fresenius-kabi.com.cn' || window.location.host == 'exmdm.fresenius-kabi.com.cn') {
  baseUrl = 'https://mdm.fresenius-kabi.com.cn/service/';
} else {
  baseUrl = 'https://fkcmdm.fresenius-kabi-sspc.com/service/'
}


export {
  baseUrl,
  routerMode,
  baseImgPath,
  logout
}




// WEBPACK FOOTER //
// ./src/config/env.js